import PropTypes from 'prop-types';

const ActionShape = PropTypes.shape({
  id: PropTypes.string,
  icons: PropTypes.objectOf(PropTypes.string),
  onClick: PropTypes.func,
});

const TreeItem = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  actions: PropTypes.arrayOf(ActionShape),
  disabled: PropTypes.bool,
};

TreeItem.children = PropTypes.arrayOf(PropTypes.shape(TreeItem));

export const TreeItemShape = PropTypes.shape(TreeItem);
export const TreeItemExact = PropTypes.exact(TreeItem);
